module.exports = __webpack_public_path__ + "static/valor-digital-services-sydney-3ef9410a5fd1f44a8037af8c321a3e89.jpg";